import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import { ESTILO_BOTON_LISTAR_NUEVO, ESTILO_BOTON_MODAL_ACEPTAR } from "../../../utils/const/estilos-const";
import sinAccesoCard from "../../../components/sin-acceso-card";
// import { Settings } from "feather-icons-react/build/IconComponents";
import { sharedNextPage } from "../../../utils/shared-functions";
// import ArrowBack from "../../../components/arrow-back";
import { useTranslation } from "react-i18next";
import ProcessingDialog from "../../../components/processing-dialog";
import ToastComponent from "../../../components/toast-component";
import { deshabilitarEstadoSolicitud, habilitarEstadoSolicitud, obtenerListaEstadoSolicitud } from "../../../api/api-estado-solicitud";
import ModalConfirmar from "../../../components/modal-confirmar";
import { sharedMensajeConfirmacion } from "../../../utils/shared-functions";
import { STRING_ID_TIPO_USUARIO_WEB, STRING_SUPER_ADMIN, STRING_ID_ROL_USUARIO_WEB } from "../../../utils/const/string-const";
import { obtenerPermisoRolUsuarioWeb } from "../../../api/api-permiso-rol-usuario-web";
import { PAGE_ID } from "../../usuarios/gestionar-rol-usuario-web/pages-const";

let $ = window.$;

export default function ListarEstadoSolicitudPage
  () {
  const idTipoUsuarioWeb = localStorage.getItem(STRING_ID_TIPO_USUARIO_WEB);
  const { t } = useTranslation();
  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  // const [listaElementos, setListaElementos] = useState([]);
  const [elementoSelected, setElementoSelected] = useState(null);
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(false);
  const [habilitadoSelected, setHabilitadoSelected] = useState(null);

  const [rowsData, setRowsData] = useState([]);
  const [btnBuscar, setBtnBuscar] = useState(false);
  const [btnNuevo, setBtnNuevo] = useState(false);
  const [btnModificar, setBtnModificar] = useState(false);
  const [btnDeshabilitar, setBtnDeshabilitar] = useState(false);
  const [btnHabilitar, setBtnHabilitar] = useState(false);

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning"); // "warning" | "success" | "error"

  const [modalConfirmarDeshabilitarVisible, setModalConfirmarDeshabilitarVisible] = useState(false);
  const [modalConfirmarHabilitarVisible, setModalConfirmarHabilitarVisible] = useState(false);

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    let tieneAcceso = false;
    try {
      let objEnviar = {};
      objEnviar.habilitado = habilitadoSelected !== null ? habilitadoSelected.value : null;
      if (idTipoUsuarioWeb === STRING_SUPER_ADMIN) {
        tieneAcceso = true;
        setBtnBuscar(true);
        setBtnNuevo(true);
        setBtnModificar(true);
        setBtnDeshabilitar(true);
        setBtnHabilitar(true);
      }
      if (idTipoUsuarioWeb !== STRING_SUPER_ADMIN) {
        const idRolUsuarioWeb = localStorage.getItem(STRING_ID_ROL_USUARIO_WEB);
        objEnviar.idRolUsuarioWeb = idRolUsuarioWeb;
        const response = await obtenerPermisoRolUsuarioWeb(objEnviar);
        if (response.error === false && response.data !== undefined) {
          const permisos = JSON.parse(response.data.permisos);
          // console.log('permisos');
          // console.log(permisos);
          if (Array.isArray(permisos) && permisos.length > 0) {
            const manage = permisos.find(p => p.id === 8);
            if (manage !== undefined && manage !== null) {
              const permisosPage = manage.subMenu.find(p => p.value === PAGE_ID.GESTIONAR_ESTADO_VIAJE);
              // console.log('permisosPage');
              // console.log(permisosPage);
              tieneAcceso = permisosPage.checked;
              if (tieneAcceso === false) {
                return;
              }
              const permisoBtnBuscar = permisosPage.acciones.find(a => a.value === 'btn_buscar');
              const permisoBtnNuevo = permisosPage.acciones.find(a => a.value === 'btn_nuevo');
              const permisoBtnModificar = permisosPage.acciones.find(a => a.value === 'btn_modificar');
              const permisoBtnDeshabilitar = permisosPage.acciones.find(a => a.value === 'btn_deshabilitar');
              const permisoBtnHabilitar = permisosPage.acciones.find(a => a.value === 'btn_habilitar');
              setBtnBuscar(permisoBtnBuscar?.checked);
              setBtnNuevo(permisoBtnNuevo?.checked);
              setBtnModificar(permisoBtnModificar?.checked);
              setBtnDeshabilitar(permisoBtnDeshabilitar?.checked);
              setBtnHabilitar(permisoBtnHabilitar?.checked);
            }
          }
        }
      }
      if (tieneAcceso === true) {
        let lista = [];

        lista = await obtenerListaEstadoSolicitud(objEnviar, false, t);
        setRowsData(lista);
      }
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
    } finally {
      setCargandoPage(false);
      setTieneAccesoAlModulo(tieneAcceso);
    }
  };

  useEffect(() => {
    // Small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      const gridElement = $("#gridContainer");
      if (gridElement.length) {
        try {
          const gridInstance = gridElement.dxDataGrid("instance");
          if (gridInstance) {
            // Grid already exists, just update the data source
            gridInstance.option("dataSource", rowsData);
          } else {
            // Grid doesn't exist yet, initialize it
            inicializarGrid();
          }
        } catch (e) {
          // Grid doesn't exist yet, initialize it
          inicializarGrid();
        }
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [rowsData]);

  const inicializarGrid = () => {
    try {
      const gridElement = $("#gridContainer");

      // Check if element exists
      if (!gridElement.length) {
        // console.warn("Grid container element not found");
        return;
      }

      // Initialize the grid
      gridElement.dxDataGrid({
        dataSource: rowsData,
        paging: {
          pageSize: 20,
        },
        pager: {
          showPageSizeSelector: true,
          allowedPageSizes: [50, 100, 150, 200],
        },
        remoteOperations: false,
        groupPanel: { visible: true },
        grouping: {
          autoExpandAll: false,
        },
        allowColumnReordering: true,
        rowAlternationEnabled: true,
        showBorders: true,
        columnAutoWidth: true,
        filterRow: {
          visible: true,
          applyFilter: "auto",
        },
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: t("grilla_placeholderbuscar"),
        },
        export: {
          enabled: true,
        },
        headerFilter: {
          visible: true,
        },
        columns: [
          {
            dataField: "acciones",
            caption: t("column_acciones"),
            width: 250,
            allowFiltering: false,
            allowSorting: false,
            cellTemplate: function (container, options) {
              // console.log("cellTemplate acciones");
              // console.log('options', options);
              // console.log('options.data', options.data);
              const buttonContainer = $("<div>").addClass("flex gap-2");
              if (btnDeshabilitar === true) {
                if (options.data.habilitado === 1) {
                  $("<button>")
                    .addClass(
                      "px-3 py-1 bg-red-500 hover:bg-red-600 text-white rounded text-sm"
                    )
                    .text(t("btn_deshabilitar"))
                    .on("click", function () {
                      cambiarEstadoDeshabilitar(options.data);
                    })
                    .appendTo(buttonContainer);
                }
              }
              if (btnHabilitar === true) {
                if (options.data.habilitado === 0) {
                  $("<button>")
                    .addClass(
                      "px-3 py-1 bg-green-500 hover:bg-green-600 text-white rounded text-sm"
                    )
                    .text(t("btn_habilitar"))
                    .on("click", function () {
                      cambiarEstadoHabilitar(options.data);
                    })
                    .appendTo(buttonContainer);
                }
              }
              if (btnModificar === true) {
                // Edit button
                $("<button>")
                  .addClass(
                    "px-3 py-1 bg-green-500 hover:bg-green-600 text-white rounded text-sm"
                  )
                  .text(t("btn_modificar"))
                  .on("click", function () {
                    modificarElementoSelected(options.data);
                  })
                  .appendTo(buttonContainer);
              }

              buttonContainer.appendTo(container);
            },
          },
          {
            dataField: "id",
            caption: "ID",
            visible: false,
          },
          {
            dataField: "codigo",
            caption: t("column_codigo"),
            visible: true,
          },
          {
            dataField: "descripcion",
            caption: t("column_descripcion"),
            visible: true,
          },
          {
            dataField: "nota",
            caption: t("column_nota"),
            visible: true,
          },
          {
            dataField: "fechaProceso",
            caption: t("column_fecha_proceso"),
            width: 200,
          },
          {
            dataField: "habilitadoLabel",
            caption: t("column_estado"),
            width: 200,
          },
          {
            dataField: "visibleParaTransportadoraLabel",
            caption: t("label_visible_para_transportadora"),
            width: 200,
          },
        ],
      });
    } catch (err) {
      console.error("Error initializing grid:", err);
    }
  };

  const modificarElementoSelected = (data) => {
    try {
      // console.log("modificarElementoSelected");
      // console.log(data);
      if (data.acciones !== undefined) {
        delete data.acciones;
      }
      let obj = {};
      obj.titulo = t("label_modificar_estado_solicitud");
      obj.params = data;
      // console.log('obj');
      // console.log(obj);
      sharedNextPage("estado-solicitud", obj, history);
    } catch (err) {
      console.log("modificarElementoSelected err");
      console.log(err);
    }
  };

  const cambiarEstadoDeshabilitar = async (data) => {
    try {
      // console.log("cambiarEstadoDeshabilitar");
      // console.log(data);
      setElementoSelected(data);
      setModalConfirmarDeshabilitarVisible(true);
    } catch (err) {
      console.log("cambiarEstadoDeshabilitar err");
      console.log(err);
    }
  };

  const cambiarEstadoHabilitar = async (data) => {
    try {
      // console.log("cambiarEstadoHabilitar");
      // console.log(data);
      setElementoSelected(data);
      setModalConfirmarHabilitarVisible(true);
    } catch (err) {
      console.log("cambiarEstadoHabilitar err");
      console.log(err);
    }
  };

  const reset = async () => {
    setCargandoPage(true);
    iniciar();
  };

  const showToast = (message, type = "warning", durationMs = 3000) => {
    setToastMessage(message);
    setToastType(type);
    setToastVisible(true);
    // Auto-hide
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      setToastVisible(false);
    }, durationMs);
  };

  const handleNuevoClick = () => {
    let obj = {};
    obj.titulo = t("label_nuevo_estado_solicitud");
    obj.params = {};
    obj.params.id = 0;
    obj.params.codigo = "";
    obj.params.descripcion = "";
    obj.params.nota = "";
    obj.params.visibleParaTransportadora = 0;
    obj.params.esViajeAprobado = 0;
    sharedNextPage("estado-solicitud", obj, history);
  };

  const handleConfirmModalDeshabilitar = async () => {
    setModalConfirmarDeshabilitarVisible(false);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    setProcessingVisible(true);
    if (elementoSelected.id !== 0) {
      // console.log('crear correo');
      const response = await deshabilitarEstadoSolicitud(objEnviar);
      setProcessingVisible(false);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        showToast(t("alert_se_deshabilito_correctamente"));
        reset();
      }
      if (response.error === true) {
        showToast(response.message, "error", 3000);
      }
    }
  };

  const handleConfirmHabilitarModal = async () => {
    setModalConfirmarHabilitarVisible(false);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    if (elementoSelected.id !== 0) {
      // console.log('crear correo');
      const response = await habilitarEstadoSolicitud(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        showToast(t("alert_se_habilito_correctamente"), "success", 3000);
        reset();
      }
      if (response.error === true) {
        showToast(response.message, "error", 3000);
      }
    }
  };

  const render = () => {
    try {
      // console.log('listar correo render');
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return sinAccesoCard();
      }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6">
          <div className="flex items-center justify-between py-4">
            <div>
              <div className="flex items-center gap-2">
                {/* <ArrowBack onClick={handleAtrasClick} /> */}
                <h2 className="text-xl font-bold text-gray-900">{t("label_gestionar_estado_solicitudes")}</h2>
              </div>
              <p className="text-sm text-gray-500">{t("label_administra_la_lista_de_estado_solicitudes")}</p>
            </div>
            {btnNuevo === true && (
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  className={ESTILO_BOTON_LISTAR_NUEVO}
                  onClick={() => {
                    handleNuevoClick();
                  }}
                >
                  {t("label_nuevo")}
                </button>
              </div>
            )}
          </div>
          <div className="grid grid-cols-12 gap-4">
            {btnBuscar === true && (
              <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
                  &nbsp;
                </label>
                <button
                  type="button"
                  className={ESTILO_BOTON_MODAL_ACEPTAR}
                  onClick={() => { reset(); }}
                >
                  {t("label_buscar")}
                </button>
              </div>
            )}
          </div>
          <br />
          {/* Grid Card */}
          <div className="bg-white border border-gray-200 rounded-lg p-2">
            <div className="min-h-[400px]">
              <div
                id="gridContainer"
                style={{
                  height: "100%",
                  width: "100%",
                }}
              />
            </div>
          </div>

          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
          <ModalConfirmar
            isOpen={modalConfirmarDeshabilitarVisible}
            onCancel={() => { setModalConfirmarDeshabilitarVisible(false); }}
            onConfirm={handleConfirmModalDeshabilitar}
            message={sharedMensajeConfirmacion(t("alert_esta_de_deshabilitar"), elementoSelected?.descripcion)}
          />
          <ModalConfirmar
            isOpen={modalConfirmarHabilitarVisible}
            onCancel={() => { setModalConfirmarHabilitarVisible(false); }}
            onConfirm={handleConfirmHabilitarModal}
            message={sharedMensajeConfirmacion(t("alert_esta_de_habilitar"), elementoSelected?.descripcion)}
          />
        </div>
      );
    } catch (err) {
      console.log('ListarPais render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
